import * as referralCoordinators from './referral'

export default Object.freeze({
  ...referralCoordinators,
})
